import {
  CaretArrowDown,
  IconButton,
  Spacer,
  useToggle,
} from '@sparemin/blockhead';
import React, { useState } from 'react';
import { useSocialShareModal } from '../SocialShareModalContext';
import { socialShareModalAccountSelectBlock as block } from '../utils';
import AccountsSelector from './AccountsSelector';
import { DEFAULT_ICON_URL } from './constants';
import SocialUserDetails from './SocialUserDetails';

export type SocialShareModalAccountSelectProps = {};

const SocialShareModalAccountSelect: React.FC<SocialShareModalAccountSelectProps> = () => {
  const [
    accountsSelectorElement,
    setAccountsSelectorElement,
  ] = useState<Element | null>(null);

  const { selectedAccount } = useSocialShareModal();

  const { username, handle, avatarSrc } = selectedAccount ?? {};

  const {
    value: isAccountsSelectorOpen,
    toggleOn: openAccountsSelector,
    toggleOff: closeAccountsSelector,
  } = useToggle(false);

  return (
    <>
      <Spacer
        orientation="horizontal"
        space="15px"
        align="center"
        justify="between"
      >
        <SocialUserDetails
          {...{ username, handle, avatarSrc: avatarSrc || DEFAULT_ICON_URL }}
        />

        <IconButton
          ref={setAccountsSelectorElement}
          className={block('accounts-selector-trigger')}
          onClick={openAccountsSelector}
        >
          <CaretArrowDown />
        </IconButton>
      </Spacer>

      <AccountsSelector
        triggerElement={accountsSelectorElement}
        isOpen={isAccountsSelectorOpen}
        onClose={closeAccountsSelector}
      />
    </>
  );
};

export default SocialShareModalAccountSelect;
